import {
    TABLE_CHECK_IN,
    TABLE_ESCALATION,
    TABLE_IN_SHOP_SCAN,
    TABLE_REFINEMENT_PRODUCTION,
    TABLE_REFINEMENT_SET,
    TABLE_REFINEMENT_SHOP,
    TABLE_RETAINER,
    TABLE_RETAINER_REFINEMENT,
    TABLE_SET,
    TABLE_SHOP_SCAN,
    TABLE_TREATMENT,
    TABLE_IMPLANT_3DSCAN,
    TABLE_IMPLANT_PLAN,
    TABLE_IMPLANT_TREATMENT,
    TABLE_REFINEMENT_BOOKING,
    TABLE_END_OF_TREATMENT,
} from './type'

import * as tableAction from '../../../table/state/action'
import {
    selectOwnState,
    selectShopScanTable,
    selectSetTable,
    selectCheckInTable,
    selectInShopScanTable,
    selectTreatmentTable,
    selectRefinementProductionTable,
    selectRefinementSetTable,
    selectRefinementShopTable,
    selectRetainerTable,
    selectRetainerRefinementTable,
    selectEscalationTable,
    selectImplant3dScanTable,
    selectImplantPlanTable,
    selectImplantTreatmentTable,
    selectEndOfTreatmentTable
} from './selector'

/* set */
export const initialTableQuerySet = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_SET)

export const changeFilterSet = tableAction.createChangeFilterAction(selectOwnState, TABLE_SET)

export const toggleSortSet = tableAction.createToggleSortAction(selectOwnState, TABLE_SET)

export const toggleMultiSortSet = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_SET)

export const gotoPageSet = tableAction.createGotoPageAction(TABLE_SET)

export const initialTableSettingsSet = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_SET)

export const toggleColumnVisibilitySet = tableAction.createToggleColumnVisibilityTableHandler(selectSetTable, TABLE_SET)


/* checkin */
export const initialTableQueryCheckIn = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_CHECK_IN)

export const changeFilterCheckIn = tableAction.createChangeFilterAction(selectOwnState, TABLE_CHECK_IN)

export const toggleSortCheckIn = tableAction.createToggleSortAction(selectOwnState, TABLE_CHECK_IN)

export const toggleMultiSortCheckIn = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_CHECK_IN)

export const gotoPageCheckIn = tableAction.createGotoPageAction(TABLE_CHECK_IN)

export const initialTableSettingsCheckIn = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_CHECK_IN)

export const toggleColumnVisibilityCheckIn = tableAction.createToggleColumnVisibilityTableHandler(selectCheckInTable, TABLE_CHECK_IN)



/* in shop scan */
export const initialTableQueryInShopScan = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_IN_SHOP_SCAN)

export const changeFilterInShopScan = tableAction.createChangeFilterAction(selectOwnState, TABLE_IN_SHOP_SCAN)

export const toggleSortInShopScan = tableAction.createToggleSortAction(selectOwnState, TABLE_IN_SHOP_SCAN)

export const toggleMultiSortInShopScan = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_IN_SHOP_SCAN)

export const gotoPageInShopScan = tableAction.createGotoPageAction(TABLE_IN_SHOP_SCAN)

export const initialTableSettingsInShopScan = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_IN_SHOP_SCAN)

export const toggleColumnVisibilityInShopScan = tableAction.createToggleColumnVisibilityTableHandler(selectInShopScanTable, TABLE_IN_SHOP_SCAN)


/* in shop */
export const initialTableQueryShopScan = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_SHOP_SCAN)

export const changeFilterShopScan = tableAction.createChangeFilterAction(selectOwnState, TABLE_SHOP_SCAN)

export const toggleSortShopScan = tableAction.createToggleSortAction(selectOwnState, TABLE_SHOP_SCAN)

export const toggleMultiSortShopScan = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_SHOP_SCAN)

export const gotoPageShopScan = tableAction.createGotoPageAction(TABLE_SHOP_SCAN)

export const initialTableSettingsShopScan = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_SHOP_SCAN)

export const toggleColumnVisibilityShopScan = tableAction.createToggleColumnVisibilityTableHandler(selectShopScanTable, TABLE_SHOP_SCAN)

/* treatment */
export const initialTableQueryTreatment = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_TREATMENT)

export const changeFilterTreatment = tableAction.createChangeFilterAction(selectOwnState, TABLE_TREATMENT)

export const toggleSortTreatment = tableAction.createToggleSortAction(selectOwnState, TABLE_TREATMENT)

export const toggleMultiSortTreatment = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_TREATMENT)

export const gotoPageTreatment = tableAction.createGotoPageAction(TABLE_TREATMENT)

export const initialTableSettingsTreatment = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_TREATMENT)

export const toggleColumnVisibilityTreatment = tableAction.createToggleColumnVisibilityTableHandler(selectTreatmentTable, TABLE_TREATMENT)


/* treatment */
export const initialTableQueryRefinementProduction = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_REFINEMENT_PRODUCTION)

export const changeFilterRefinementProduction = tableAction.createChangeFilterAction(selectOwnState, TABLE_REFINEMENT_PRODUCTION)

export const toggleSortRefinementProduction = tableAction.createToggleSortAction(selectOwnState, TABLE_REFINEMENT_PRODUCTION)

export const toggleMultiSortRefinementProduction = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_REFINEMENT_PRODUCTION)

export const gotoPageRefinementProduction = tableAction.createGotoPageAction(TABLE_REFINEMENT_PRODUCTION)

export const initialTableSettingsRefinementProduction = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_REFINEMENT_PRODUCTION)

export const toggleColumnVisibilityRefinementProduction = tableAction.createToggleColumnVisibilityTableHandler(selectRefinementProductionTable, TABLE_REFINEMENT_PRODUCTION)


/* refinement set */
export const initialTableQueryRefinementSet = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_REFINEMENT_SET)

export const changeFilterRefinementSet = tableAction.createChangeFilterAction(selectOwnState, TABLE_REFINEMENT_SET)

export const toggleSortRefinementSet = tableAction.createToggleSortAction(selectOwnState, TABLE_REFINEMENT_SET)

export const toggleMultiSortRefinementSet = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_REFINEMENT_SET)

export const gotoPageRefinementSet = tableAction.createGotoPageAction(TABLE_REFINEMENT_SET)

export const initialTableSettingsRefinementSet = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_REFINEMENT_SET)

export const toggleColumnVisibilityRefinementSet = tableAction.createToggleColumnVisibilityTableHandler(selectRefinementSetTable, TABLE_REFINEMENT_SET)


/* refinement shop */
export const initialTableQueryRefinementShop = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_REFINEMENT_SHOP)

export const changeFilterRefinementShop = tableAction.createChangeFilterAction(selectOwnState, TABLE_REFINEMENT_SHOP)

export const toggleSortRefinementShop = tableAction.createToggleSortAction(selectOwnState, TABLE_REFINEMENT_SHOP)

export const toggleMultiSortRefinementShop = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_REFINEMENT_SHOP)

export const gotoPageRefinementShop = tableAction.createGotoPageAction(TABLE_REFINEMENT_SHOP)

export const initialTableSettingsRefinementShop = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_REFINEMENT_SHOP)

export const toggleColumnVisibilityRefinementShop = tableAction.createToggleColumnVisibilityTableHandler(selectRefinementShopTable, TABLE_REFINEMENT_SHOP)


/* refinement booking */
export const initialTableQueryRefinementBooking = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_REFINEMENT_BOOKING)

export const changeFilterRefinementBooking = tableAction.createChangeFilterAction(selectOwnState, TABLE_REFINEMENT_BOOKING)

export const toggleSortRefinementBooking = tableAction.createToggleSortAction(selectOwnState, TABLE_REFINEMENT_BOOKING)

export const toggleMultiSortRefinementBooking = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_REFINEMENT_BOOKING)

export const gotoPageRefinementBooking = tableAction.createGotoPageAction(TABLE_REFINEMENT_BOOKING)


/* retainer */
export const initialTableQueryRetainer = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_RETAINER)

export const changeFilterRetainer = tableAction.createChangeFilterAction(selectOwnState, TABLE_RETAINER)

export const toggleSortRetainer = tableAction.createToggleSortAction(selectOwnState, TABLE_RETAINER)

export const toggleMultiSortRetainer = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_RETAINER)

export const gotoPageRetainer = tableAction.createGotoPageAction(TABLE_RETAINER)

export const initialTableSettingsRetainer = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_RETAINER)

export const toggleColumnVisibilityRetainer = tableAction.createToggleColumnVisibilityTableHandler(selectRetainerTable, TABLE_RETAINER)


/* retainer */
export const initialTableQueryRetainerRefinement = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_RETAINER_REFINEMENT)

export const changeFilterRetainerRefinement = tableAction.createChangeFilterAction(selectOwnState, TABLE_RETAINER_REFINEMENT)

export const toggleSortRetainerRefinement = tableAction.createToggleSortAction(selectOwnState, TABLE_RETAINER_REFINEMENT)

export const toggleMultiSortRetainerRefinement = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_RETAINER_REFINEMENT)

export const gotoPageRetainerRefinement = tableAction.createGotoPageAction(TABLE_RETAINER_REFINEMENT)

export const initialTableSettingsRetainerRefinement = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_RETAINER_REFINEMENT)

export const toggleColumnVisibilityRetainerRefinement = tableAction.createToggleColumnVisibilityTableHandler(selectRetainerRefinementTable, TABLE_RETAINER_REFINEMENT)


/* escalation */
export const initialTableQueryEscalation = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_ESCALATION)

export const changeFilterEscalation = tableAction.createChangeFilterAction(selectOwnState, TABLE_ESCALATION)

export const toggleSortEscalation = tableAction.createToggleSortAction(selectOwnState, TABLE_ESCALATION)

export const toggleMultiSortEscalation = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_ESCALATION)

export const gotoPageEscalation = tableAction.createGotoPageAction(TABLE_ESCALATION)

export const initialTableSettingsEscalation = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_ESCALATION)

export const toggleColumnVisibilityEscalation = tableAction.createToggleColumnVisibilityTableHandler(selectEscalationTable, TABLE_ESCALATION)

/* end of treatment */
export const initialTableQueryEndOfTreatment = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_END_OF_TREATMENT)

export const changeFilterEndOfTreatment = tableAction.createChangeFilterAction(selectOwnState, TABLE_END_OF_TREATMENT)

export const toggleSortEndOfTreatment = tableAction.createToggleSortAction(selectOwnState, TABLE_END_OF_TREATMENT)

export const toggleMultiSortEndOfTreatment = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_END_OF_TREATMENT)

export const gotoPageEndOfTreatment = tableAction.createGotoPageAction(TABLE_END_OF_TREATMENT)

export const initialTableSettingsEndOfTreatment = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_END_OF_TREATMENT)

export const toggleColumnVisibilityEndOfTreatment = tableAction.createToggleColumnVisibilityTableHandler(selectEndOfTreatmentTable, TABLE_END_OF_TREATMENT)


/* implant 3d scan */
export const initialTableQueryImplant3dScan = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_IMPLANT_3DSCAN)

export const changeFilterImplant3dScan = tableAction.createChangeFilterAction(selectOwnState, TABLE_IMPLANT_3DSCAN)

export const toggleSortImplant3dScan = tableAction.createToggleSortAction(selectOwnState, TABLE_IMPLANT_3DSCAN)

export const toggleMultiSortImplant3dScan = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_IMPLANT_3DSCAN)

export const gotoPageImplant3dScan = tableAction.createGotoPageAction(TABLE_IMPLANT_3DSCAN)

export const initialTableSettingsImplant3dScan = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_IMPLANT_3DSCAN)

export const toggleColumnVisibilityImplant3dScan = tableAction.createToggleColumnVisibilityTableHandler(selectImplant3dScanTable, TABLE_IMPLANT_3DSCAN)


/* implant plan */
export const initialTableQueryImplantPlan = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_IMPLANT_PLAN)

export const changeFilterImplantPlan = tableAction.createChangeFilterAction(selectOwnState, TABLE_IMPLANT_PLAN)

export const toggleSortImplantPlan = tableAction.createToggleSortAction(selectOwnState, TABLE_IMPLANT_PLAN)

export const toggleMultiSortImplantPlan = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_IMPLANT_PLAN)

export const gotoPageImplantPlan = tableAction.createGotoPageAction(TABLE_IMPLANT_PLAN)

export const initialTableSettingsImplantPlan = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_IMPLANT_PLAN)

export const toggleColumnVisibilityImplantPlan = tableAction.createToggleColumnVisibilityTableHandler(selectImplantPlanTable, TABLE_IMPLANT_PLAN)


/* implant treatment */
export const initialTableQueryImplantTreatment = tableAction.createInitialTableQueryAction(selectOwnState, TABLE_IMPLANT_TREATMENT)

export const changeFilterImplantTreatment = tableAction.createChangeFilterAction(selectOwnState, TABLE_IMPLANT_TREATMENT)

export const toggleSortImplantTreatment = tableAction.createToggleSortAction(selectOwnState, TABLE_IMPLANT_TREATMENT)

export const toggleMultiSortImplantTreatment = tableAction.createToggleMultiSortAction(selectOwnState, TABLE_IMPLANT_TREATMENT)

export const gotoPageImplantTreatment = tableAction.createGotoPageAction(TABLE_IMPLANT_TREATMENT)

export const initialTableSettingsImplantTreatment = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_IMPLANT_TREATMENT)

export const toggleColumnVisibilityImplantTreatment = tableAction.createToggleColumnVisibilityTableHandler(selectImplantTreatmentTable, TABLE_IMPLANT_TREATMENT)




// WEBPACK FOOTER //
// ./src/modules/sales-order/state/search/action.js